"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _DataDisplayWidget = _interopRequireDefault(require("./Style/DataDisplayWidget"));

var _utils = _interopRequireDefault(require("../../../../utils"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _axios = _interopRequireDefault(require("axios"));

var _errorPage = _interopRequireDefault(require("./../../../error-views/errorPage"));

var _TableData = _interopRequireDefault(require("./TableData"));

var _AddRM = _interopRequireDefault(require("../AddRM"));

var _reactCsv = require("react-csv");

var _CardData = _interopRequireDefault(require("./CardData"));

var _RmName = _interopRequireDefault(require("../../../../RmName.json"));

var innerwidth = window.innerWidth;
var header = [{
  label: "CLcode",
  key: "CL_Code"
}, {
  label: _RmName.default.name,
  key: "RM_Name"
}, {
  label: _RmName.default.nameCode,
  key: "RM_code"
}, {
  label: "Total_student",
  key: "Total_student"
}, {
  label: "Status",
  key: "Status"
}, {
  label: "Phone_Number",
  key: "Phone_Number"
}, {
  label: "Start_Date",
  key: "Start_Date"
}, {
  label: "Address",
  key: "Address"
}, {
  label: "End_date",
  key: "End_date"
}, {
  label: "Reasons_for_Leaving",
  key: "Reasons_for_Leaving"
}, {
  label: "Maths RR",
  key: "MathRR"
}, {
  label: "English RR",
  key: "EngRR"
}];
var Option = _antd.Select.Option;
var lastRM = {};

var RM = function RM() {
  var date = new Date();
  var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
  var time = "".concat(date.getHours(), ":").concat(date.getMinutes());
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      allData = _useState8[0],
      setAllData = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      searchData = _useState10[0],
      setSearchData = _useState10[1];

  var _useState11 = (0, _react.useState)("Add new ".concat(_RmName.default.name)),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      btnName = _useState12[0],
      setBtnName = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      addNew = _useState14[0],
      setAddNew = _useState14[1]; // useEffect(async () => {
  //   getData();
  // }, []);
  // useEffect(() => {
  //   async function fetchData() {
  //     getData();
  //   }
  //   fetchData();
  // },[]); 


  (0, _react.useEffect)(function () {
    function getData() {
      return _getData.apply(this, arguments);
    }

    function _getData() {
      _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var url;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _config.default.rmDetails + cl;
                _context.next = 3;
                return _axios.default.get(url, {
                  headers: {
                    'Authorization': token
                  }
                }).then(function (response) {
                  if (response.data.status === "error") setapiError(response.data);else {
                    var rmDetails = response.data;
                    setData(rmDetails);
                    setAllData(rmDetails);
                    setSearchData(rmDetails);
                    setLoading(false);
                  }
                }, function (error) {
                  var obj = {
                    "status": "error",
                    "message": "Network Error"
                  };
                  if (error.response) setapiError(error.response);else setapiError(obj);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getData.apply(this, arguments);
    }

    getData(); // eslint-disable-next-line 
  }, []);
  var csvRport = {
    filename: "RM Data ".concat(today, " ").concat(time),
    headers: header,
    data: data
  };

  var onSearch = function onSearch(e) {
    var value = e.currentTarget.value;

    var searchdata = _utils.default.wildCardSearch(searchData, value);

    setData(searchdata);
  };

  var handleStatusRequest = function handleStatusRequest(value) {
    if (value !== 'All') {
      var key = 'Status';

      var details = _utils.default.filterArray(allData, key, value);

      setData(details);
      setSearchData(details);
    } else {
      setData(allData);
      setSearchData(allData);
    }
  };

  var AddNew = function AddNew() {
    setAddNew(!addNew);

    if (btnName === "Add new ".concat(_RmName.default.name)) {
      setBtnName("Back to ".concat(_RmName.default.name, " List"));
    } else {
      setBtnName("All new ".concat(_RmName.default.name));
    }

    if (allData.length === 0) {
      var _data = {
        RM_code: 1
      };
      lastRM = _data;
    } else {
      var _data2 = {
        RM_code: allData.length + 1
      };
      lastRM = _data2;
    }
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, addNew ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AddRM.default, {
    rmCodeJson: lastRM,
    btnName: btnName,
    AddNew: AddNew
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 20,
    xl: 20,
    xxl: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Filter"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [8, 8]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 9,
    xl: 9,
    xxl: 9
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Search",
    prefix: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, null),
    onChange: function onChange(e) {
      return onSearch(e);
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 9,
    xl: 9,
    xxl: 9
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("b", null, "Status")), "\xA0", /*#__PURE__*/_react.default.createElement(_antd.Select, {
    defaultValue: "All",
    style: {
      width: '80%'
    },
    onChange: handleStatusRequest,
    placeholder: "Status"
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "All"
  }, "All"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Active"
  }, "Active"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Inactive"
  }, "Inactive")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 5,
    xl: 5,
    xxl: 5
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    onClick: function onClick() {
      return AddNew();
    }
  }, btnName))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 4,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_DataDisplayWidget.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserSwitchOutlined, null),
    value: data.length,
    title: "Total ".concat(_RmName.default.attendance),
    color: "cyan",
    size: "20",
    vertical: true,
    avatarSize: 30,
    style: {
      height: 132
    }
  }))), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "ALL RM",
    style: {
      'fontSize': '5px',
      backgroundColor: '#f5f5f5'
    },
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, innerwidth > 425 ? /*#__PURE__*/_react.default.createElement(_TableData.default, {
    data: data
  }) : /*#__PURE__*/_react.default.createElement(_CardData.default, {
    data: data
  }))));
};

var _default = RM;
exports.default = _default;